import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useDispatch } from "react-redux"

import { FormControl, Grid, MenuItem, Select } from "@mui/material"
import useStylesSeeMoreOrganization from "./useStyleSeeMoreOrganization"
import CloseIcon from "@mui/icons-material/Close"
import { helpGetOrganizationWithID } from "../../../../app/services/Organization/helpGetOrganizationWithID"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
} from "../../../../redux/actions/app"
import {
  getDataUserOrganizationID,
  getOrganizationCommercialUserType,
  getTraducTypeOrg,
} from "../../../../redux/actions/Organizations"
import { getTraducTypeUser } from "../../../../utils/UserTools"
import { useState, useEffect } from "react"
import {
  deleteCustomerUser,
  getAllTypesUser,
  updateUserOrganization,
} from "../../../../redux/actions/User"
import { getSubscriberUserCorpEntities } from "../../../../app/services/Suscriber/getSubscriberUserCorpEntities"
import ModalConfirmChange from "../../Organizations/User/ModalConfirmChange/ModalConfirmChange"
import { getUserStatusCorpEntities } from "../../../../app/services/Organization/getUserStatusCorpEntities"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined"

import { helpGetUserLoginAccountWithEmail } from "../../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail"

export default function StepperSeeMoreOrganization({
  setstateSeeMore,
  item,
  setLoading,
}) {
  const classes = useStylesSeeMoreOrganization()

  const dispatch = useDispatch()
  const [organization, setOrganization] = React.useState(null)

  const [userData, setuserData] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState(
    userData?.state?.userStatusCode ?? "",
  )
  const currentUserOrgStatusCode = userData?.status?.userStatusCode || ""
  const currentUserTypeCode = userData?.type?.organizationUserTypeCode || ""
  const [statesUserOrg, setStatesUserOrg] = useState([])
  const codeStatesEnabled = ["ACTIVE", "DELETED", "WAITING_VALIDATION"]
  const codeTypesEnabled = ["ORG-STAFF", "ORG-ADMIN"]
  const [isModalOpenTypeUser, setisModalOpenTypeUser] = useState(false)
  // const filteredUserOrgStatus = statesUserOrg.filter((option) =>
  //   codeStatesEnabled.includes(option.userStatusCode),
  // )
  const currentUserTypeComercialCode = userData?.commercialType?.organizationCommercialUserTypeCode || ""

  const [selectedType, setSelectedType] = useState(
    userData?.type?.organizationUserTypeCode ?? "",
  )
  const [isModalOpenStatusUserOrg, setisModalOpenStatusUserOrg] =
    useState(false)

  const [typesUser, settypesUser] = useState([])

  const [typeComercial, setTypeComercial] = useState(
    item.commercialType?.organizationCommercialUserTypeCode,
  )
  const [typesComercial, setTypesComercial] = useState([])

  const [isModalOpenTypeComercialUserOrg, setIsModalOpenTypeComercialUserOrg] =
    useState(false)

  const handleChangeTypeComercial = (event) => {
    setTypeComercial(event.target.value)
    setIsModalOpenTypeComercialUserOrg(true)
  }

  const handleChangeTypeComercialUser = async () => {
    const status = await dispatch(
      updateUserOrganization({
        organizationUserId: userData.userId,
        organizationCommercialUserTypeCode: typeComercial,
      }),
    )
    if (status) {
      const refreshTypeComercial = typesComercial.find((item) => item.organizationCommercialUserTypeCode === typeComercial)
      const commercialType = {
        organizationCommercialUserTypeCode: refreshTypeComercial.organizationCommercialUserTypeCode,
        organizationCommercialUserTypeName: refreshTypeComercial.organizationCommercialUserTypeName,
      }
      setuserData({
        ...userData,
        commercialType,
      })
    }
  }
  // // get user info request
  const handleGetOrganizationWithID = async () => {
    try {
      const response = await helpGetOrganizationWithID(item.organizationId)
      setOrganization(response.data?.data)
    } catch (error) {
      // error
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
    }
  }
  const getAllTypes = async () => {
    try {
      const types = await dispatch(getAllTypesUser())
      settypesUser(types)
    } catch (error) {
      console.log(error)
    }
  }

  // get organinzation details of reducer
  useEffect(async () => {
    setLoading(true)
    await handleGetOrganizationWithID()
    // setLoading(false)
  }, [])
  useEffect(async () => {
    if (organization && !organization.typeTraduc) {
      setLoading(true)
      const orgWithTypeOrgTraduc = organization
      orgWithTypeOrgTraduc.typeTraduc = await getTraducTypeOrg(
        organization.organizationTypeId,
      )
      setOrganization(orgWithTypeOrgTraduc)

      // setLoading(false)
    }
  }, [organization])

  const handleOpenModalType = (value) => {
    setSelectedType(value)
    setisModalOpenTypeUser(true)
  }
  const getUserOrgStatus = async () => {
    try {
      const status = await getUserStatusCorpEntities()
      setStatesUserOrg(status.data?.data)
    } catch (error) {
      console.log(error)
    }
  }
  const handleOpenModalChangeStatus = (value, type) => {
    setSelectedStatus(value)

    setisModalOpenStatusUserOrg(true)
  }
  const handleCloseModal = () => {
    setisModalOpenStatusUserOrg(false)
    setisModalOpenTypeUser(false)
    setIsModalOpenTypeComercialUserOrg(false)
  }

  const handleChangeTypeUser = async () => {
    const status = await dispatch(
      updateUserOrganization({
        organizationUserId: userData.userId,
        organizationUserTypeCode: selectedType,
      }),
    )

    if (Number(status?.organizationUserTypeId)) {
      const getByStatusId = typesUser.find(
        (option) =>
          option.organizationUserTypeId ===
          Number(status.organizationUserTypeId),
      )

      const type = {
        organizationUserTypeCode: getByStatusId.organizationUserTypeCode,
        organizationUserTypeName: getByStatusId.organizationUserTypeName,
      }
      setuserData({
        ...userData,
        type,
      })
    }
  }

  const getSubscriber = async () => {
    try {
      const userId = userData.userId
      const response = await getSubscriberUserCorpEntities(userId)
      return {
        subscriberRefId: response?.data?.[0].subscriber_ref_id,
        organizationId: response?.data?.[0].organization_id,
      }
    } catch (error) {
      return 0
    }
  }

  const userStatusConfig = {
    ACTIVE: {
      color: "green",
      icon: CheckCircleIcon,
      label: "Activo",
    },
    DELETED: {
      color: "red",
      icon: CancelIcon,
      label: "Dado de Baja",
    },
    WAITING_VALIDATION: {
      color: "blue",
      icon: HourglassTopOutlinedIcon,
      label: "Esperando Validación",
    },
  }

  const getStatusConfig = (statusCode) => {
    return (
      userStatusConfig[statusCode] || {
        color: "#aaa",
        icon: CheckCircleIcon,
        label: "Estado desconocido",
      }
    )
  }

  const StatusDisplay = ({ statusCode, statusName, disabled = false }) => {
    const config = getStatusConfig(statusCode)
    const IconComponent = config.icon
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {!disabled && (
          <IconComponent sx={{ color: config.color, fontSize: "20px" }} />
        )}
        <Typography sx={{ color: config.color }}>
          {statusName || config.label}
        </Typography>
      </Box>
    )
  }
  const handleChangeStatusUser = async () => {
    let isSuccessful = false
    let newStatus = null
    try {
      const updateStatus = await dispatch(
        updateUserOrganization({
          organizationUserId: userData.userId,
          userStatusCode: selectedStatus,
        }),
      )
      if (updateStatus?.error || !Number(updateStatus?.userStatusId)) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar("Ocurrió un error al actualizar el estado"),
        )
        return
      }
      const getByStatusId = statesUserOrg.find(
        (option) => option.userStatusId === Number(updateStatus.userStatusId),
      )
      newStatus = {
        userStatusCode: getByStatusId.userStatusCode,
        userStatusName: getByStatusId.userStatusName,
      }
      if (selectedStatus === "DELETED") {
        const subscriberData = await getSubscriber()

        if (!subscriberData) {
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar(
              "Ocurrió un error, no se pudo obtener información del suscriptor",
            ),
          )
          return
        }
        const deleteResult = await dispatch(
          deleteCustomerUser({
            clicod: subscriberData.subscriberRefId,
            organizationId: subscriberData.organizationId,
            userId: userData.userId,
            email: userData.account.email,
            deactivationReason: "DELETED",
          }),
        )

        if (deleteResult?.error) {
          console.log("Error al eliminar el usuario")
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar("Ocurrió un error al eliminar el usuario"),
          )
          return
        } else {
          isSuccessful = true
        }
      } else {
        isSuccessful = true
      }
    } catch (error) {
      console.log("Error:", error)
    }
    if (isSuccessful && newStatus) {
      setuserData({
        ...userData,
        status: newStatus,
      })
    }
  }

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }
  const getUserStatusLoginAccount = async (email, data) => {
    try {
      const status = await helpGetUserLoginAccountWithEmail(email)

      setuserData({
        ...data,
        accountStatus: status?.data?.loginAccount?.accountStatus,
      })
    } catch (error) {
      console.log(error)
    }
  }
  const loadUserData = async () => {
    setLoading(true)
    const response = await dispatch(getDataUserOrganizationID(item.userId))
    if (response !== "Error") {
      await getUserStatusLoginAccount(
        response.data.account.email,
        response.data,
      )
      await getAllTypes()
      await getUserOrgStatus()
      const typesC = await dispatch(getOrganizationCommercialUserType())
      setTypesComercial(typesC.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadUserData()
  }, [])

  const SeeMoreOrganizationOfID = ({ item }) => {
    return (
      organization &&
      userData && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Nombre de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationName || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Nombre legal de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationLegalName || "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                CUIT de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationCuit || "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Máximo de cuentas:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationMaxAccessCount || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                ID de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.organizationId || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Fecha de creación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(organization.creationDate) || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Creado por:</Typography>
            </Grid>

            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.creationUser || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Última modificación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(organization.creationDate) || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Modificado por:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {organization.modificationUser || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Tipo del usuario:</Typography>
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <Typography className={classes.value}>
                {getTraducTypeUser(item.type?.organizationUserTypeCode) ||
                  "- -"}
              </Typography> */}
              <Grid
                item
                xs={5}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <FormControl
                  // variant="outlined"
                  style={{ minWidth: 160 }}
                  className={classes.value}
                >
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    sx={{
                      height: 30,
                      border: "2px solid rgb(104, 106, 109)",
                      "& .MuiSelect-icon": {
                        color: "rgb(75, 77, 78)",
                      },
                      "&:hover": {
                        borderColor: "rgb(0, 167, 143)",
                      },
                    }}
                    value={currentUserTypeCode}
                    onChange={(e) => handleOpenModalType(e.target.value)}
                    renderValue={(selected) => {
                      if (!selected)
                        return <span style={{ color: "#aaa" }}>- -</span>
                      const selectedItem = typesUser.find(
                        (item) => item.organizationUserTypeCode === selected,
                      )
                      return (
                        getTraducTypeUser(
                          selectedItem?.organizationUserTypeCode,
                        ) || "- -"
                      )
                    }}
                  >
                    {typesUser.map((item) => (
                      <MenuItem
                        key={item.organizationUserTypeId}
                        value={item.organizationUserTypeCode}
                        disabled={
                          !codeTypesEnabled.includes(
                            item.organizationUserTypeCode,
                          ) ||
                          !codeTypesEnabled.includes(
                            userData?.type?.organizationUserTypeCode,
                          )
                        }
                      >
                        {getTraducTypeUser(item.organizationUserTypeCode)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Tipo comercial del usuario:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControl style={{ minWidth: 160 }}
                className={classes.value}>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={currentUserTypeComercialCode}
                  onChange={handleChangeTypeComercial}
                  renderValue={(selected) => {
                    if (!selected)
                      return <span style={{ color: "#aaa" }}>- -</span>
                    const selectedItem = typesComercial.find(
                      (item) => item.organizationCommercialUserTypeCode === selected,
                    )
                    return (

                      selectedItem?.organizationCommercialUserTypeName || ""
                    )
                  }}
                >
                  {typesComercial ? (
                    typesComercial.map((t) => (
                      <MenuItem
                        key={t.organizationCommercialUserTypeName}
                        value={t.organizationCommercialUserTypeCode}
                      >
                        {t.organizationCommercialUserTypeName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="">
                      No se encontraron tipos comerciales
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Estado del usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Grid
                item
                xs={5}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <FormControl
                  variant="outlined"
                  style={{ minWidth: 160 }}
                  className={classes.value}
                >
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    sx={{
                      height: 30,
                      border: "2px solid rgb(104, 106, 109)",
                      "& .MuiSelect-icon": {
                        color: "rgb(75, 77, 78)",
                      },
                      "&:hover": {
                        borderColor: "rgb(0, 167, 143)",
                      },
                      display: "flex",
                      justifyContent: "center",
                    }}
                    value={currentUserOrgStatusCode}
                    onChange={(e) =>
                      handleOpenModalChangeStatus(e.target.value, "user_org")
                    }
                    renderValue={(selected) => {
                      if (!selected)
                        return <span style={{ color: "#aaa" }}>- -</span>
                      const selectedItem = statesUserOrg.find(
                        (item) => item.userStatusCode === selected,
                      )
                      // return selectedItem?.userStatusName || "- -"
                      if (!selectedItem) return "- -"

                      return (
                        <StatusDisplay
                          statusCode={selectedItem.userStatusCode}
                          statusName={selectedItem.userStatusName}
                        />
                      )
                    }}
                  >
                    {statesUserOrg.map((item) => {
                      return (
                        <MenuItem
                          key={item.userStatusId}
                          value={item.userStatusCode}
                          disabled={
                            !codeStatesEnabled.includes(item.userStatusCode)
                          }
                        >
                          <StatusDisplay
                            statusCode={item.userStatusCode}
                            statusName={item.userStatusName}
                            disabled={
                              !codeStatesEnabled.includes(item.userStatusCode)
                            }
                          />
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
                {isModalOpenTypeUser && (
                  <ModalConfirmChange
                    title={"Confirmar cambio de tipo de usuario-organización"}
                    message={"¿Estás seguro de cambiar el tipo del usuario?"}
                    onClose={handleCloseModal}
                    onConfirm={handleChangeTypeUser}
                  />
                )}

                {isModalOpenStatusUserOrg && (
                  <ModalConfirmChange
                    title="Confirmar cambio de estado"
                    message={`¿Estás seguro de cambiar el estado del usuario-organización?`}
                    onClose={handleCloseModal}
                    onConfirm={handleChangeStatusUser}
                  />
                )}
                {isModalOpenTypeComercialUserOrg && (
                  <ModalConfirmChange
                    title="Confirmar cambio de tipo comercial"
                    message={`¿Estás seguro de cambiar el tipo comercial del usuario?`}
                    onClose={handleCloseModal}
                    onConfirm={handleChangeTypeComercialUser}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                ID de usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {item.userId || "- -"}
              </Typography>
            </Grid>
          </Grid>
        </>
      )
    )
  }

  return (
    <Box className={classes.backgroundBox}>
      <div
        style={{
          width: "100%",
          display: "flex",
          padding: "8px 0px 8px 0px",
          justifyContent: "space-between",
          boxShadow: "0px 1px 1px #EAEAEA",
          color: "#8C8C8C",
        }}
      >
        <Typography className={classes.seeMoreTypography}>
          Información de la organización asociada al usuario{" "}
          {item.account?.firstName + " " + item.account?.lastName}
        </Typography>
        <CloseIcon
          style={{
            cursor: "pointer",
            paddingRight: 10,
            fontSize: "1.5rem",
          }}
          onClick={() => {
            setstateSeeMore(false)
          }}
        />
      </div>
      <Box className={classes.mainBox}>
        <SeeMoreOrganizationOfID item={item} />
      </Box>
      <ButtonClose setstateSeeMore={setstateSeeMore} />
    </Box>
  )
}

function ButtonClose({ setstateSeeMore }) {
  const classes = useStylesSeeMoreOrganization()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          "&:hover": {
            bgcolor: "#1BF57F",
          },
        }}
      >
        <Typography
          onClick={() => {
            setstateSeeMore(false)
          }}
          className={classes.closeButtonTypography}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
